import Main from '@/components/main';
import UserManagement from './user-management';
import ProjectManagement from './project-management';
import AreaManagement from './area-management';
import PackageManagement from './package-management';
import DepartmentManagement from './department-management';
import SuggestionManagement from './suggestion-management';
import BlockedUserManagement from './blocked-user-management';
import ActionManagement from './action-management';
import NoticeManagement from './notice-management';
import AboutContactingUsManagement from './aboutcontacing-management';
import PersonalNoticeManagment from './personalnotice-managment';
import PayManagement from './pay-management';
import CompanyManagment from './company-management'; 
export default {
    path: '/system-management',
    name: 'system-management',
    meta: {
        icon: 'ios-man',
        title: '系统管理',
        showAlways: true
    },
    component: Main,
    children: [
        ...UserManagement,
        //...ProjectManagement,
        ...BlockedUserManagement,
        ...AreaManagement,
        ...PackageManagement,
        ...DepartmentManagement,
        ...CompanyManagment,
        ...SuggestionManagement,
        ...NoticeManagement,
        ...PersonalNoticeManagment,
        ...ActionManagement,
        ...AboutContactingUsManagement,
        ...PayManagement,
        {
            path: 'system-user-center',
            name: 'system-user-center',
            meta: {
                icon: 'ios-apps',
                title: '个人中心',
                notCache: true,
                hideInMenu: true,
                items: [
                ]
            },
            component: () => import('@/view/system-management/user-management/user-center')
        },
        {
            path: 'ad-management',
            name: 'ad-management',
            meta: {
                icon: 'md-people',
                title: '广告设置',
                notCache: true,
                access: ['S'],
                items: [
                ]
            },
            component: () => import('@/view/system-management/ad-management/ad-management')
        },
        {
            path: 'system-update-password',
            name: 'system-update-password',
            meta: {
                icon: 'md-people',
                title: '修改账号密码',
                notCache: true,
                access: ['S'],
                items: [
                ]
            },
            component: () => import('@/view/system-management/system-update-password/system-update-password')
        },
        {
		    path: 'region-management',
		    name: 'region-management',
		    meta: {
		        icon: 'md-people',
		        title: '省市区管理',
		        notCache: true,
		        access: ['S'],
		        items: [
		        ]
		    },
		    component: () => import('@/view/system-management/region-management/region-management')
        },
        {
            path: 'log-management',
            name: 'log-management',
            meta: {
                icon: 'ios-apps',
                title: '操作日志',
                notCache: true,
		        access: ['S'],
                items: [
                ]
            },
            component: () => import('@/view/system-management/log-management/log-management.vue')
        },
        {
            path: 'request-log-management',
            name: 'request-log-management',
            meta: {
                icon: 'ios-apps',
                title: '请求日志',
                notCache: true,
		        access: ['S'],
                items: [
                ]
            },
            component: () => import('@/view/system-management/request-log-management/request-log-management.vue')
        },
        {
            path: 'request-log-statistic',
            name: 'request-log-statistic',
            meta: {
                icon: 'ios-apps',
                title: '请求日志图表',
                notCache: true,
		        access: ['S'],
                items: [
                ]
            },
            component: () => import('@/view/system-management/request-log-management/request-log-statistic.vue')
        },
        {
            path: 'ys-log-management',
            name: 'YSLogManagement',
            meta: {
                icon: 'ios-apps',
                title: '用友日志管理',
                notCache: true,
		        access: ['S'],
                items: [
                ]
            },
            component: () => import('@/view/system-management/ys-log-management/ys-log-management.vue')
        }
        // {
        //     path: 'system-setting',
        //     name: 'system-setting',
        //     meta: {
        //         icon: 'ios-apps',
        //         title: '系统参数设置',
        //         notCache: true,
        //         access: ['S'],
        //         items: [
        //         ]
        //     },
        //     component: () => import('@/view/system-management/system-setting/system-setting')
        // }
        // {
        //     path: 'system-tobedone2',
        //     name: 'system-tobedone2',
        //     meta: {
        //         icon: 'ios-apps',
        //         title: '缤纷会员注册',
        //         notCache: true,
        //         access: ['S'],
        //         items: [
        //         ]
        //     },
        //     component: () => import('@/view/tobedone')
        // }
    ]
};
